import { useContext, useEffect, useState } from "react";
import { MenuItem, TextField } from '@mui/material';
import BuilderContext from '../../../../store/BuilderContext';
import AuthContext from "../../../../store/AuthContext";

const MaxHeight = (props) => {
  const { blockId, screenType } = props;
  const builderCtx = useContext(BuilderContext);
  const authCtx = useContext(AuthContext);
  const { contentBlocks, updateContentBlocks, currentContentBlock, updateCurrentBlock } = builderCtx;

  // Get current block styles
  const getCurrentBlockStyles = () => {
    switch (screenType) {
      case "mobile":
        return currentContentBlock?.mobileStyling;
      case "horizontal":
        return currentContentBlock?.horizontalStyling;
      case "vertical":
        return currentContentBlock?.verticalStyling;
      default:
        return currentContentBlock?.styling;
    }
  };

  const currentBlockStyles = getCurrentBlockStyles();
  const currentMaxHeight = currentBlockStyles?.maxHeight?.match(/[a-zA-Z]+|[0-9]+|[%]/g);

  // Define units options for height
  const units = [
    { value: 'px', label: 'px' },
    { value: 'rem', label: 'rem' },
    { value: '%', label: '%' },
    { value: 'vh', label: 'vh' },
    { value: 'vw', label: 'vw' },
  ];

  const [maxHeight, setMaxHeight] = useState(currentMaxHeight?.[0] || "auto");
  const [unit, setUnit] = useState(currentMaxHeight?.[1] || "px");
  const [finalValue, setFinalValue] = useState("");
  const [onChangeFlag, setOnChangeFlag] = useState(false);

  if (maxHeight !== "auto") localStorage.setItem("prevMaxHeight", maxHeight);

  const handleUnitChange = (e) => {
    setOnChangeFlag(true);
    if (!e.target.value) {
      setMaxHeight("auto");
    } else {
      setUnit(e.target.value);
      if (localStorage.getItem("prevMaxHeight")) {
        setMaxHeight(localStorage.getItem("prevMaxHeight"));
      }
    }
  };

  const updateMaxHeight = (maxHeightValue, unit) => {
    let payload = {
      id: blockId,
      value: maxHeightValue !== 'auto' ? maxHeightValue + unit : maxHeightValue,
      screenType: props.screenType,
    };

    fetch(`${process.env.REACT_APP_API_URI}/v3/admin/assessment/styling/maxHeight`, {
      method: 'PUT',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + authCtx.token,
      },
      body: JSON.stringify(payload),
    })
      .then(response => response.json())
      .then(data => {
        if (data.status === "success") {
          console.log("Updating maxHeight payload", payload);
        }
      })
      .catch(err => {
        console.error("Failed to update maxHeight...", err);
      });
  };

  useEffect(() => {
    if (maxHeight === "auto") {
      setFinalValue("auto");
    } else if (maxHeight && maxHeight !== "auto" && unit) {
      if (maxHeight !== currentMaxHeight?.[0] || unit !== currentMaxHeight?.[1]) {
        setFinalValue(`${maxHeight}${unit}`);
      }
    }
  }, [currentMaxHeight, maxHeight, unit]);

  useEffect(() => {
    let lastFinalVal = "";
    if (!currentMaxHeight?.[1]) {
      lastFinalVal = "auto";
    } else {
      lastFinalVal = `${currentMaxHeight?.[0]}${currentMaxHeight?.[1]}`;
    }

    if (onChangeFlag) {
      updateMaxHeight(maxHeight, unit);
    }

    const timer = setTimeout(() => {
      if (finalValue && finalValue !== lastFinalVal) {
        switch (screenType) {
          case "mobile":
            updateContentBlocks(contentBlocks.map(block => {
              if (block.id === blockId) {
                return {
                  ...block,
                  mobileStyling: {
                    ...block.mobileStyling,
                    maxHeight: finalValue,
                  },
                };
              }
              if (block.id === blockId) {
                updateCurrentBlock(block);
              }
              return block;
            }));
            break;
          case "horizontal":
            updateContentBlocks(contentBlocks.map(block => {
              if (block.id === blockId) {
                return {
                  ...block,
                  horizontalStyling: {
                    ...block.horizontalStyling,
                    maxHeight: finalValue,
                  },
                };
              }
              if (block.id === blockId) {
                updateCurrentBlock(block);
              }
              return block;
            }));
            break;
          case "vertical":
            updateContentBlocks(contentBlocks.map(block => {
              if (block.id === blockId) {
                return {
                  ...block,
                  verticalStyling: {
                    ...block.verticalStyling,
                    maxHeight: finalValue,
                  },
                };
              }
              if (block.id === blockId) {
                updateCurrentBlock(block);
              }
              return block;
            }));
            break;
          default:
            updateContentBlocks(contentBlocks.map(block => {
              if (block.id === blockId) {
                return {
                  ...block,
                  styling: {
                    ...block.styling,
                    maxHeight: finalValue,
                  },
                };
              }
              if (block.id === blockId) {
                updateCurrentBlock(block);
              }
              return block;
            }));
            break;
        }
      }

      setOnChangeFlag(false);
    }, 500);

    return () => clearTimeout(timer);
  }, [blockId, finalValue, unit, contentBlocks, screenType, updateContentBlocks, updateCurrentBlock, currentMaxHeight, onChangeFlag]);

  return (
    <div className="maxHeight tool">
      {props.deleteModal}
      <TextField
        id="maxHeight-number"
        className="maxHeight-input styling-input"
        type="number"
        variant="filled"
        InputLabelProps={{ shrink: true }}
        placeholder={maxHeight}
        value={maxHeight}
        onChange={e => {
          if (e.target.value) {
            setMaxHeight(e.target.value);
          } else {
            setMaxHeight("auto");
          }
          setOnChangeFlag(true);
        }}
      />

      <TextField
        className="maxHeight-unit styling-select"
        select
        variant="standard"
        InputProps={{ disableUnderline: true }}
        placeholder={currentContentBlock.styling?.maxHeight}
        value={unit}
        onChange={handleUnitChange}
      >
        {units.map(option => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </TextField>
    </div>
  );
};

export default MaxHeight;
